/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Careof1Inputs */

const de__field_careof1 = /** @type {(inputs: _Field_Careof1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresszusatz`)
};

/**

* @param {_Field_Careof1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_careof1 = /** @type {((inputs?: _Field_Careof1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Careof1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_careof1(inputs)
});
export { _field_careof1 as "_field_careOf" }